const LETTER_REGEX = /\p{L}/u;
const MARK_REGEX = /\p{M}/u;
const RTL_RANGES = [
    [0x0590, 0x05ff], // Hebrew
    [0x0600, 0x06ff], // Arabic
    [0x0750, 0x077f], // Arabic Supplement
    [0x08a0, 0x08ff], // Arabic Extended-A
    [0xfb1d, 0xfdff], // Hebrew/Arabic presentation forms
    [0xfe70, 0xfeff], // Arabic presentation forms
];
function isRtlCharacter(character) {
    const codePoint = character.codePointAt(0);
    return (codePoint != null && RTL_RANGES.some(([start, end]) => codePoint >= start && codePoint <= end));
}
function stripMarkdownDirectionalNoise(text) {
    return text
        .replace(/```[\s\S]*?```/g, ' ')
        .replace(/`[^`]*`/g, ' ')
        .replace(/\[([^\]]+)\]\([^)]+\)/g, '$1')
        .replace(/https?:\/\/\S+/g, ' ');
}
function computeDominantTextDirection(text) {
    let currentRunDirection = null;
    let rtlRuns = 0;
    let ltrRuns = 0;
    for (const character of text) {
        if (MARK_REGEX.test(character)) {
            continue;
        }
        if (!LETTER_REGEX.test(character)) {
            currentRunDirection = null;
            continue;
        }
        const characterDirection = isRtlCharacter(character) ? 'rtl' : 'ltr';
        if (characterDirection === currentRunDirection) {
            continue;
        }
        if (characterDirection === 'rtl') {
            rtlRuns += 1;
        }
        else {
            ltrRuns += 1;
        }
        currentRunDirection = characterDirection;
    }
    if (rtlRuns === 0) {
        return 'ltr';
    }
    return rtlRuns >= ltrRuns ? 'rtl' : 'ltr';
}
export function getDominantTextDirection(text) {
    return computeDominantTextDirection(text ?? '');
}
export function getDominantTextDirectionMd(text) {
    return computeDominantTextDirection(stripMarkdownDirectionalNoise(text ?? ''));
}
export function getRtlDirectionOverride(text) {
    return getDominantTextDirection(text) === 'rtl' ? 'rtl' : undefined;
}
export function getRtlDirectionOverrideMd(text) {
    return getDominantTextDirectionMd(text) === 'rtl' ? 'rtl' : undefined;
}
//# sourceMappingURL=textDirection.js.map